export const ASSETS_DOMAIN =
  import.meta.env.VITE_ASSETS_DOMAIN ?? import.meta.env.ASSETS_DOMAIN

export const USER_TYPE_DEFAULT = 1
export const USER_TYPE_ESTABLISHMENT = 2
export const USER_TYPE_FRANCHISEE = 3
export const USER_TYPE_ADMINISTRATOR = 4
export const USER_TYPE_DELIVERYMAN = 5

export const MODAL_CLOSE_BY_CALL = 1
export const MODAL_CLOSE_BY_BACK_BUTTON = 2
export const MODAL_CLOSE_BY_WRAPPER = 3

export const CASHBACK_MODE_ACCUMULATE = 1
export const CASHBACK_MODE_RESCUE = 2

export const MESSAGE_TYPE_INFO = 1
export const MESSAGE_TYPE_WARNING = 2
export const MESSAGE_TYPE_SUCCESS = 3
export const MESSAGE_TYPE_DANGER = 4

export const ORDER_SEND_STATUS_SENDING = 0
export const ORDER_SEND_STATUS_SENT = 1
export const ORDER_SEND_STATUS_RECEIVED = 2
export const ORDER_SEND_STATUS_RECEIVED_VISUALIZED = 3
export const ORDER_SEND_STATUS_ERROR = 4

export const ORDER_STATUS_CREATED = -9
export const ORDER_STATUS_WAITING_PAYMENT = -8
export const ORDER_STATUS_PROCESSING_PAYMENT = -7
export const ORDER_STATUS_PAYMENT_REFUSED = -6
export const ORDER_STATUS_WAITING_CONFIRMATION = -1
export const ORDER_STATUS_PLACED = 0
export const ORDER_STATUS_IN_PRODUCTION = 1
export const ORDER_STATUS_READY_FOR_PICKUP = 2
export const ORDER_STATUS_DISPATCHED = 3
export const ORDER_STATUS_DELIVERED = 4
export const ORDER_STATUS_CONCLUDED = 5
export const ORDER_STATUS_CANCELED = 6
export const ORDER_STATUS_DELAYED = 7

export const SCHEDULING_MODE_DISABLED = 0
export const SCHEDULING_MODE_OPTIONAL = 1
export const SCHEDULING_MODE_FORCED = 2

export const EXTRA_TYPE_RADIO = 1
export const EXTRA_TYPE_CHECKBOX = 2
export const EXTRA_TYPE_NUMBER = 3

export const COMPANY_STATUS_OFFLINE = 0
export const COMPANY_STATUS_ONLINE = 1
export const COMPANY_STATUS_BUSY = 2
export const COMPANY_STATUS_UNAVAILABLE = 3

export const ESTABLISHMENT_STATUS_OFFLINE = 0
export const ESTABLISHMENT_STATUS_ONLINE = 1
export const ESTABLISHMENT_STATUS_BUSY = 2
export const ESTABLISHMENT_STATUS_UNAVAILABLE = 3

export const SECTION_TYPE_PIZZA = 2

export const ROUND_PRICE_UP = 1
export const ROUND_PRICE_DOWN = 2

export const PRICE_TYPE_AVERAGE = 1
export const PRICE_TYPE_MORE_EXPENSIVE = 2
export const PRICE_TYPE_CHEAPER = 4

export const USER_PASSWORD_MIN_LENGTH = 6

export const DIALOG_TYPE_ALERT = 2
export const DIALOG_TYPE_CONFIRM = 3
export const DIALOG_TYPE_LOADING = 4

export const THE_TRUE_ARRAY = [true, 'true', 1, '1', 'on']

export const BANNER_CLICK_TYPE_NONE = null
export const BANNER_CLICK_TYPE_URL = 1
export const BANNER_CLICK_TYPE_SCRIPT = 2
export const BANNER_CLICK_TYPE_ROUTE = 3

export const DELIVERY_TIME_MODE_ONLY_DELIVERY_WAY = 1
export const DELIVERY_TIME_MODE_MOST_TIME = 2
export const DELIVERY_TIME_MODE_SUM = 3
export const DELIVERY_TIME_MODE_AVERAGE = 4

export const DELIVERY_TIME_MODE_LONGEST_TIME = 1
export const DELIVERY_TIME_MODE_SHORTEST_TIME = 2
export const DELIVERY_TIME_MODE_SUM_TIMES = 3
export const DELIVERY_TIME_MODE_AVERAGE_TIMES = 4

export const DELIVERY_TIME_RULE_TYPE_SECTION = 1
export const DELIVERY_TIME_RULE_TYPE_CATEGORY = 2
export const DELIVERY_TIME_RULE_TYPE_PRODUCT = 3
export const DELIVERY_TIME_RULE_TYPE_OPERATIONAL = 4
export const DELIVERY_TIME_RULE_TYPE_GENERAL = 5

export const PAYMENT_FORM_METHOD_OTHER = 0
export const PAYMENT_FORM_METHOD_MONEY = 1
export const PAYMENT_FORM_METHOD_CREDIT_CARD = 2
export const PAYMENT_FORM_METHOD_DEBIT_CARD = 3
export const PAYMENT_FORM_METHOD_PIX_MANUAL = 4
export const PAYMENT_FORM_METHOD_PIX_AUTO = 21
export const PAYMENT_FORM_METHOD_CHEQUE = 5
export const PAYMENT_FORM_METHOD_MEAL_VOUCHER = 6
export const PAYMENT_FORM_METHOD_FOOD_VOUCHER = 7
export const PAYMENT_FORM_METHOD_BOLETO = 8
export const PAYMENT_FORM_METHOD_CASHBACK = 9
export const PAYMENT_FORM_METHOD_DIGITAL_WALLET = 10
export const PAYMENT_FORM_METHOD_ONLINE_PAYMENT = 20

export const PAYMENT_CARD_TYPE_DEBIT = 1
export const PAYMENT_CARD_TYPE_CREDIT = 2

export const POINTS_STEP_PRICE = 0.5

export const MASK_CPF = '###.###.###-##'

export const DAYS_OF_THE_WEEK = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
]

export const FAVORITE_TYPE_COMPANY = 1
export const FAVORITE_TYPE_PRODUCT = 2

export const COMPANIES_GROUP_TYPE_LIST = 1
export const COMPANIES_GROUP_TYPE_CAROUSEL = 2
export const COMPANIES_GROUP_TYPE_CATEGORY = 3

export const USER_VALIDATION_CHANNEL_EMAIL = 1
export const USER_VALIDATION_CHANNEL_SMS = 2
export const USER_VALIDATION_CHANNEL_WHATSAPP = 3
export const USER_VALIDATION_CHANNEL_CALL = 4

export const USER_VALIDATION_TYPE_EMAIL = 1
export const USER_VALIDATION_TYPE_PHONE_NUMBER = 2

export const COMPANY_RATING_OPTION_NOT_LIKED = 1
export const COMPANY_RATING_OPTION_LIKED = 2
export const COMPANY_RATING_OPTION_LOVED = 3
export const COMPANY_RATING_OPTIONS = {
  [COMPANY_RATING_OPTION_NOT_LIKED]: {
    label: 'Ñ Gostei',
    classname: 'not-liked',
    icon: '/images/icons/thumb_down.svg',
  },
  [COMPANY_RATING_OPTION_LIKED]: {
    label: 'Gostei',
    classname: 'liked',
    icon: '/images/icons/thumb_up.svg',
  },
  [COMPANY_RATING_OPTION_LOVED]: {
    label: 'Adorei',
    classname: 'loved',
    icon: '/images/icons/thumb_up_2.svg',
  },
}

export const ORDER_MODIFICATION_SOURCE_CASHBACK = 1
export const ORDER_MODIFICATION_SOURCE_COUPON = 2
export const ORDER_MODIFICATION_SOURCE_RULE = 3

export const ORDER_MODIFICATION_TARGET_ORDER = 1
export const ORDER_MODIFICATION_TARGET_ITEMS = 2
export const ORDER_MODIFICATION_TARGET_ITEM = 3
export const ORDER_MODIFICATION_TARGET_ITEM_PRODUCT = 4
export const ORDER_MODIFICATION_TARGET_ITEM_SECTION = 6
export const ORDER_MODIFICATION_TARGET_ITEM_SECTION_CATEGORY = 7
export const ORDER_MODIFICATION_TARGET_DELIVERY_FEE = 5

export const ORDER_MODIFICATION_SPONSOR_TYPE_MARKETPLACE = 1
export const ORDER_MODIFICATION_SPONSOR_TYPE_COMPANY = 2

export const ORDER_ORIGIN_CLIENT = 1
export const ORDER_ORIGIN_COMPANY = 2
